import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { AccountContext } from '../../../components/AccountContext';
import AccountInvitationDetail from './AccountInvitationDetail';

export const ACCOUNT_INVITATION_QUERY = gql`
  query AccountInvitationQuery($accountId: ID!, $invitationId: ID!) {
    account(id: $accountId) {
      id
      companyInformation {
        displayName
      }
      pendingClientInvitation(id: $invitationId) {
        id,
        fullName
        email
        inviteMessage
        partner
        assessmentTemplates {
          id,
          title
        },
        assessmentSections {
          behaviorSection {
            displayName,
            dimensions {
              id,
              name,
              displayName
            },
            distortionDimensions {
              id,
              name,
              displayName
            }
          },
          cognitiveSection {
            displayName,
            dimensions {
              id,
              name,
              displayName
            }
          },
          interestsSection {
            displayName,
            dimensions {
              id,
              name,
              displayName
            }
          }
        }
        surveyTemplates {
          id,
          title
        },
        surveyCompetencies {
          id,
          displayName,
          abilities {
            id,
            displayName
          }
        }
      }
    }
  }
`;

const AccountInvitationContainer = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { invitationId } = useParams();

  const variables = {
    accountId: currentAccount,
    invitationId,
  };

  return (
    <Query query={ACCOUNT_INVITATION_QUERY} variables={variables}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        return <AccountInvitationDetail data={data} />;
      }}
    </Query>
  );
};

export default AccountInvitationContainer;
